import secondaryComponents from "../../../../../components/secondaryComponents";
import { motion } from "framer-motion";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import primaryComponents from "../../../../../components/primaryComponents";
import { useAllActivityLogs } from "./useAllActivityLogs";
import { ActivityLogsTable } from "../../../../../components/secondaryComponents/ActivityLogs";

export const AllActivityLogs = () => {
  const {
    search,
    activityLogs,
    metaDetails,
    isLoading,
    storeList,
    activityModules,
    userList,
    filterByDate,
    gotoPage,
    filterBySearch,
    filterByKey,
    filterByStoreId,
  } = useAllActivityLogs();

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Activity Logs"
      description="See all activities performed by all users"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={` ${globalStyles.pagePaddings} ${globalStyles.pageColumnGaps}`}
        >
          <div>
            <h4 className="mb-0">Activity Logs</h4>
            <p>Track every action taken within your account</p>
          </div>

          <div className={globalStyles.pageHeaders}>
            <p>{metaDetails?.total || 0} Activities</p>
          </div>

          <div className={`${globalStyles.tableWrapper}`}>
            <div className={`${globalStyles.tableHeader}`}>
              <primaryComponents.SearchField
                placeholder="Search by activity logs"
                trigger={(value) => filterBySearch(value)}
                value={search.get("query") !== null ? search.get("query") : ""}
                triggerOnInput={true}
                showsearchBtn
                classNames={`${globalStyles.searchField}`}
              />
              <div className="ml-auto" style={{ width: "200px" }}>
                <primaryComponents.SelectField
                  options={[
                    { name: "All Modules", id: null },
                    ...activityModules,
                  ]}
                  idKey="id"
                  nameKey="name"
                  onChange={(value) => {
                    filterByKey("module_id", value);
                  }}
                  value={
                    activityModules?.find(
                      (module) => `${module?.id}` === search.get("module_id"),
                    )?.name || "Filter Module"
                  }
                  floatError={false}
                />
              </div>

              <div style={{ width: "200px" }}>
                <primaryComponents.SelectField
                  options={[{ name: "All Stores", id: null }, ...storeList]}
                  idKey="id"
                  nameKey="name"
                  onChange={(value) => {
                    filterByStoreId(value);
                  }}
                  value={
                    storeList?.find(
                      (store) => `${store?.id}` === search.get("store_id"),
                    )?.name || "Filter Store"
                  }
                  floatError={false}
                />
              </div>

              <div style={{ width: "200px" }}>
                <primaryComponents.SelectField
                  options={[
                    { first_name: "All Initiators", id: null },
                    ...userList,
                  ]}
                  idKey="id"
                  nameKey="first_name"
                  onChange={(value) => {
                    filterByKey("initiator_id", value);
                  }}
                  value={
                    userList?.find(
                      (item) => `${item?.id}` === search.get("initiator_id"),
                    )?.first_name || "Filter Initiator"
                  }
                  floatError={false}
                />
              </div>
              <primaryComponents.DateRangeInput
                startDate={search.get("start_date")}
                endDate={search.get("end_date")}
                onChange={filterByDate}
                showPlaceholder={true}
              />
            </div>

            {/* table section */}
            <secondaryComponents.LoaderHelper
              isLoading={isLoading}
              classNames="mt-5"
            >
              <ActivityLogsTable
                activityLogs={activityLogs}
                gotoPage={gotoPage}
                metaDetails={metaDetails}
              />
            </secondaryComponents.LoaderHelper>
          </div>
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};
